import { useNavigate } from "react-router"
import { useEffect } from "react"
import { SERVICE_CENTER_REPORTS_ROUTE } from "../../../constants/routes"

type Props = Readonly<{}>

export function ServiceCenterHome({}: Props) {
    const navigate = useNavigate()

    useEffect(() => navigate(SERVICE_CENTER_REPORTS_ROUTE))

    return null
}
